<template>
    <v-col
      cols="12"
      md="1"
    >
    <slot></slot>
  </v-col>
</template>

<script>
export default {
  name: "Col1"
}
</script>

<style scoped>

</style>